export default __webpack_public_path__ + "images/SA.8515371.png";